/**
 * 判断输入变量的类型,有两种方式,当只输入obj时,则返回该变量的类型,如果同时输入type则会对比输入类型是否和type相同
 *
 * @param {*} obj
 * @param {*} type
 * @returns
 */
function checkTypeof(obj,type) {
  var class2type = {};
  "Boolean Number String Function Array Date RegExp Object Error".split(" ").forEach(function (e, i) {
    class2type["[object " + e + "]"] = e.toLowerCase();
  });
  let result
  if(!type){
    if (obj == null) {
      result = String(obj);
    }else{
      result = typeof obj === "object" || typeof obj === "function" ?
      class2type[class2type.toString.call(obj)] || "object" :
      typeof obj;
    }
  }else{
    if (obj == null) {
      result = String(obj) === type;
    }else{
      result = (typeof obj === "object" || typeof obj === "function" ?
      class2type[class2type.toString.call(obj)] || "object" :
      typeof obj) === type;
    }
  }
  return result
}
module.exports = checkTypeof